import { call, put } from 'redux-saga/effects';
import { Auth } from 'aws-amplify';
import ActionTypes from '@ziynx/action-types';
import { eventNames } from '@ziynx/analytics';

export function* checkStatus(): Generator<any, void, empty> {
  try {
    const currentUser = yield call(() => Auth.currentSession());
    // Get the company groups the user is a part of
    const { accessToken } = currentUser;

    const companySetupTest = /company/g;
    const companyGroups = (accessToken?.payload['cognito:groups'] || []).filter((group) => companySetupTest.test(group));
    const isAdmin = (accessToken?.payload['cognito:groups'] || []).includes('admins');

    yield put({
      type: ActionTypes.auth.checkIfLoggedIn.SUCCESS,
      response: {
        isLoggedIn: true,
        isLogOut: false,
        companyGroups,
        isAdmin,
      },
    });

    yield put({
      type: ActionTypes.analytics.changeUser.START,
      sub: accessToken?.payload?.sub,
    });
  } catch (err) {
    // When the user is not authenticated, dont throw an error.
    const unauthenticatedError = err === 'The user is not authenticated';

    yield put({
      type: unauthenticatedError
        ? ActionTypes.auth.checkIfLoggedIn.SUCCESS
        : ActionTypes.auth.checkIfLoggedIn.ERROR,
      response: { isLoggedIn: false, isLogOut: false },
    });
  }
}

export function* checkAdmin(): Generator<AnyAction, void, empty> {
  try {
    yield put({
      type: ActionTypes.auth.checkIfAdmin.SUCCESS,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.auth.checkIfAdmin.ERROR,
      error,
    });
  }
}

export function* signUp(action) {
  const { username, password, attributes } = action;
  try {
    const response = yield call(() => Auth.signUp({ username, password, attributes }));

    yield put({
      type: ActionTypes.auth.signUp.SUCCESS,
      response: {
        success: true,
      },
    });

    yield put({
      type: ActionTypes.analytics.changeUser.START,
      sub: response?.userSub,
    });

    yield put({
      type: ActionTypes.analytics.setCustomAttribute.START,
      key: 'user_type',
      value: 'company',
    });
  } catch (error) {
    yield put({
      type: ActionTypes.auth.signUp.ERROR,
      response: { success: false, error },
    });
  }
}

export function* verifyAccount(action) {
  const { username, password, code } = action;
  try {
    yield call(() => Auth.confirmSignUp(username, code));
    yield call(() => Auth.signIn({
      username,
      password,
      validationData: { platform: 'web' },
    }));

    yield put({
      type: ActionTypes.auth.verifyAccount.SUCCESS,
      response: {
        success: true,
      },
    });

    if (!action?.invited) {
      yield put({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.onboarding_verified_email,
      });
    } else {
      yield put({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.onboarding_verified_invited_email,
      });
    }

    yield put({
      type: ActionTypes.auth.checkIfLoggedIn.START,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.auth.verifyAccount.ERROR,
      response: { success: false, error },
    });
    if (!action?.invited) {
      yield put({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.onboarding_verified_email_error,
      });
    } else {
      yield put({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.onboarding_verified_invited_email_error,
      });
    }
  }
}

export function* logout(): Generator<any, void, empty> {
  try {
    yield call(() => Auth.signOut());
    yield put({
      type: ActionTypes.auth.checkIfLoggedIn.START,
    });

    yield put({
      type: ActionTypes.auth.logout.SUCCESS,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.auth.logout.ERROR,
      error,
    });
  }
}
